import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const Header = dynamic(() => import('./Header'));

Builder.registerComponent(Header, {
	name: 'Header',
	inputs: [
		{
			name: 'copy',
			friendlyName: 'Heading',
			type: 'richText',
			required: true,
			defaultValue: '<p><strong>Time is <u>LIMITED</u> to File!</strong></p>',
		},
		{
			name: 'logo',
			friendlyName: 'Logo',
			type: 'reference',
			model: 'header-logo',
			defaultValue: {
				'@type': '@builder.io/core:Reference',
				id: '65145887550344c68e37ac08ce75d9a4',
				model: 'header-logo',
			},
		},
		{
			name: 'usePageColors',
			friendlyName: 'Use Page Colors',
			type: 'boolean',
			defaultValue: true,
			helperText: `If true, will use colors set on page for styling;
			if false, use the controls below`,
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#555555',
			helperText: 'Be sure to select a color light enough for the text to have contrast',
			// eslint-disable-next-line object-shorthand
			showIf: function (options) {
				return options.get('usePageColors') === false;
			},
		},
		{
			name: 'textColor',
			friendlyName: 'Text Color',
			type: 'color',
			defaultValue: '#FFF',
			helperText: 'Be sure to select a color light enough for the text to have contrast',
			// eslint-disable-next-line object-shorthand
			showIf: function (options) {
				return options.get('usePageColors') === false;
			},
		},
		{
			name: 'mobileStack',
			friendlyName: 'Stack on Mobile',
			type: 'boolean',
			defaultValue: true,
			helperText: 'Stack the header elements in a column at mobile sizes.',
		},
		{
			name: 'mobileLogo',
			friendlyName: 'Mobile Logo',
			type: 'boolean',
			defaultValue: true,
			helperText: 'Should the logo be shown at mobile sizes?',
		},
		{
			name: 'mobileText',
			friendlyName: 'Mobile Text',
			type: 'boolean',
			defaultValue: true,
			helperText: `Should text be shown at mobile sizes?
				Will default to mobile text only if none are selected.`,
		},
		{
			name: 'mobileButton',
			friendlyName: 'Mobile Button',
			type: 'boolean',
			defaultValue: true,
			helperText: `If there is a button present, should it be shown at mobile sizes?
				Button is not recommended when layout is not stacked.`,
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: 'See if I Qualify',
					arrow: true,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $in: ['Button'] } },
	},
	image: getIconUrl(Icon.HEADER),
});
